import { computed } from 'vue'

import type { RouteLocationNormalizedGeneric } from '#vue-router'
import type { ComputedRef } from 'vue'

import { AppRoute } from '@ts-routes/enums'

export interface StaticRoutesPayload {
  route: RouteLocationNormalizedGeneric
}
interface StaticRoutesReturn {
  isRouteProfile: ComputedRef<boolean>
  isRoutePayments: ComputedRef<boolean>
  isRoutePaymentsSubscriptions: ComputedRef<boolean>
  isRoutePaymentsMethods: ComputedRef<boolean>
  isRoutePaymentsHistory: ComputedRef<boolean>
  isRouteReferral: ComputedRef<boolean>
  isMoreStaticRoute: ComputedRef<boolean>
}
export const useStaticRoutes = (payload: StaticRoutesPayload): StaticRoutesReturn => {
  const path = computed(() => payload.route.path)

  const isRouteProfile = computed(() => path.value === AppRoute.Profile)
  const isRoutePayments = computed(() => path.value === AppRoute.Payments)
  const isRoutePaymentsSubscriptions = computed(() => path.value === AppRoute.PaymentsSubscriptions)
  const isRoutePaymentsMethods = computed(() => path.value === AppRoute.PaymentsMethods)
  const isRoutePaymentsHistory = computed(() => path.value === AppRoute.PaymentsHistory)
  const isRouteReferral = computed(() => path.value === AppRoute.Referral)

  const isMoreStaticRoute = computed(() => {
    return isRouteProfile.value
    || isRoutePayments.value
    || isRoutePaymentsSubscriptions.value
    || isRoutePaymentsMethods.value
    || isRoutePaymentsHistory.value
    || isRouteReferral.value
  })

  return {
    isRouteProfile,
    isRoutePayments,
    isRoutePaymentsSubscriptions,
    isRoutePaymentsMethods,
    isRoutePaymentsHistory,
    isRouteReferral,
    isMoreStaticRoute,
  }
}
